import { Component, Input, OnInit } from '@angular/core';
import { CalcsService } from '../calcs.service';

@Component({
  selector: 'app-property-icon',
  templateUrl: './property-icon.component.html',
  styleUrls: ['./property-icon.component.css']
})
export class PropertyIconComponent implements OnInit {

  @Input() property: any
  constructor(public calcService: CalcsService) { }

  ngOnInit(): void {
  }

  selectProperty(type) {
    this.calcService.rm.propertyType = type
    this.calcService.rm.hpiVal = this.calcService.hpi[type]
    this.calcService.amended = true
  }
}
